var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{staticClass:"logo",attrs:{"src":_vm.url,"alt":""}}),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }